import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import TermsHeroSection from './termsHeroSection';

const Terms = () => {
    return (
        <Layout >
            <div
                style={{ background: "radial-gradient(75% 25% at 50% 0%, rgb(216 223 235), rgb(255, 255, 255))" }}
            >
                <PageMeta />
                <Navbar />
                <section
                    className='page-header position-relative overflow-hidden pt-60 pb-60 '
                >
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12'>
                                <div className='text-center'>
                                    <h1 className=' fw-bold'>Terms of service</h1>
                                    <p className='lead'>
                                        We are Senertech Software Private Limited, doing business as Senertech (“company”, “we”, “us”, or “our”), a company registered in India. We operate the website https://www.senertech.in (the “site”), as well as any other related products and services that refer or link to these terms of service (the “terms”) (collectively, the “services”).
                                    </p>
                                    <p className='lead'>
                                        These terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”), and Senertech Software Private Limited, concerning your access to and use of the services. You agree that by accessing the services, you have read, understood, and agreed to be bound by all these terms. If you do not agree with all these terms, then you are expressly prohibited from using the services, and you must discontinue use immediately.
                                    </p>
                                    <p className='lead'>
                                        We will provide you with prior notice of any scheduled changes to the services you are using. The modified terms will become effective upon posting or notifying you by no-reply@senertech.in, as stated in the email message. By continuing to use the services after the effective date of any changes, you agree to be bound by the modified terms.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <TermsHeroSection />

                <FooterOne
                    style={{
                        background:
                            "url('assets/img/page-header-bg.svg')no-repeat bottom left",
                    }}
                />
            </div>
        </Layout>
    );
};

export default Terms;
